import { handleResult, postForm, reloadSoon } from '../http';
import confirmDialog from './confirm-dialog';

// Delete confirmation for the list pages. Rows ask with:
//   $dispatch('delete-request', { id, name })
// `navigate: true` follows GET {url}?{field}=<id> (the SEO pages); otherwise it
// POSTs `{field}=<id>` to `url`, then reloads the page when `reload` is set.
export default ({ url, field, noun, navigate = false, reload = false }) => ({
  ...confirmDialog(),

  ask({ id, name }) {
    this.show({
      title: `Delete this ${noun}?`,
      name,
      message: 'will be deleted.',
      confirmLabel: 'Delete',
      tone: 'danger',
      action: async () => {
        if (navigate) {
          window.location.href = `${url}?${new URLSearchParams({ [field]: id })}`;
          return true;
        }

        handleResult(await postForm(url, { [field]: id }));

        if (reload) {
          reloadSoon();
        }
      },
    });
  },
});
